module.exports = __webpack_public_path__ + "static/media/left-bottom-shade.2f480478.png";